import { SaleTaxAndFees } from "./sale-tax-and-fees.model";

export class Sale {
    /** Unique internal identity of the sale. */
    public id: number;

    /** Unique internal identity of the lot associated with the sale. */
    public lotId: number;
    
    /** Name of the lot associated with the sale. */
    public lot: string;

    /** Unique internal identity of the sale stage associated with the sale. */
    public saleStageId: number;
    
    /** The name of the sale stage associated with the sale. (sale, quote) */
    public stage: string;
    
    /** Unique internal identity of the sale status associated with the sale. */
    public saleStatusId: number;
    
    /** The name of the sale status associated with the sale. (pending, sold, repoed, etc...) */
    public status: string;

    /** The sale status group indicating if the sale is active or closed and other groups. */
    public group: string;

    /** Unique internal identity of the sale type associated with the sale. */
    public saleFinancingTypeId: number; 

    /** Unique internal identity of the collector (user) record associated with the sale. */
    public collectorId: number;

    /** Full name of the user employee who is marked as the collector on this account, if any. */
    public collector: string;

    /** Indicates the sale is a Buy Here - Pay Here (BHPH) type. */
    public bhph: boolean;

    /** Indicates the sale is either BHPH or Outside Financed types. */
    public financed: boolean;

    /** Unique internal identity of the buyer contact record associated with the sale. */
    public contactId: number;

    /** Unique internal identity of the buyer type associated with the sale. */
    public saleBuyerTypeId: number;

    /** The buyer type name associated with the sale. */
    public buyerType: string;

    /** The buyer type code associated with the sale. */
    public buyerTypeCode: string;
    
    /** The sale type name associated with the sale. (bhph, outside finance, wholesale, cash) */
    public type: string;

    /** Unique internal identity of the vehicle status associated with the sale. */
    public vehicleStatusId: number;
    
    /** The name of the vehicle status associated with the sale. (make ready, sold, quoted, available, etc...) */
    public vehicleStatus: string;
    
    /** Date the sale was created. */
    public saleDate: Date;
    public sold: Date;

    /** Date the quote will expire. */
    public expirationDate: Date;
    public expires: Date;
    
    /** Indicates whether or not the sale is considered out of state. (typically no taxes) */
    public outOfState: boolean;
    
    /** The base sale price. */
    public salePrice: number;
    
    /** The drive off the lot price after all products, taxes, fees, down payments, etc... have been applied. */
    public driveOutPrice: number;
    
    /** The total sale price which is the base sale price plus any products and trade payoffs. */
    public totalSalePrice: number;
    
    /** Indicates whether or not the sale is locked (no changes). */
    public locked: boolean;

    /** The sale terms collection method used (Scheduled Installment Earnings SIE or True Daily Earnings TDE) */
    public collectionMethod: string;
    
    /** The sale terms tax method used (paid or deferred) */
    public taxMethod: string;
    
    /** Full or company name of the buyer associated with the sale. */
    public buyer: string;
    
    /** Primary residence or place of business street address associated with the sale buyer. */
    public address: string;
    
    /** Primary residence or place of business street address addenda associated with the sale buyer. */
    public address2: string;
    
    /** Primary residence or place of business city associated with the sale buyer. */
    public city: string;
    
    /** Primary residence or place of business state associated with the sale buyer. */
    public state: string;
    
    /** Primary residence or place of business postal (zip) code associated with the sale buyer. */
    public zipCode: string;
    
    /** Primary residence or place of business county associated with the sale buyer. */
    public county: string;
    
    /** Indicates whether or not the buyer is an individual (true) or company or goverment entity (false). */
    public isIndividual: boolean;
    
    /** Current sale vehicle mileage. */
    public mileage: number;

    /** Unique internal identity of the vehicle inventory record associated with the sale. */
    public inventoryId: number;
    
    /** Date when the sale vehicle was added to the lot. */
    public received: Date;
    
    /** The stock number associated with the sale vehicle. */
    public stock: string;
    
    /** The identifcation number (vin) associated with the sale vehicle. */
    public vin: string;
    
    /** The year of manufacture associated with the sale vehicle. */
    public year: number;
    
    /** The  manufacturer (make) associated with the sale vehicle. */
    public make: string;
    
    /** The model associated with the sale vehicle. */
    public model: string;

    /** The year, make and model of the sale vehicle all combined into one string. */
    public vehicle: string;
    
   /** The sale vehicle exterior color. */
    public exteriorColor: string;
    
    /** The sale vehicle secondary exterior color, if any. */
    public exteriorColorMinor: string;
    
    /** The sale vehicle interior color. */
    public interiorColor: string;
    
    /** A URL to the sale vehicle image, if any. */
    public url: string;
    
    /** Name of the lienholder associated with the sale terms. (for bhph this is the lot name) */
    public lienholder: string;

    /** The current payoff amount of the active sale terms. */
    public payoff: number;

    /** The current scheduled payment amount of the active sale terms. */
    public payment: number;

    /** The current payment frequency (cycle) of the active sale terms. */
    public paymentCycle: string;

    /** The first scheduled payment due date of the active sale terms. */
    public first: Date;

    /** Total trade allowance for any trades associated with the sale. */
    public tradeAllowance: number;

    /** Total trade payoff for any trades associated with the sale. */
    public tradePayoff: number;

    /** Total trade acv (actual cash value) for any trades associated with the sale. */
    public tradeAcv: number;

    /** Total of any scheduled deposits associated with the sale.  */
    public deposit: number;

    /** Total of any scheduled initial down payments associated with the sale. */
    public initial: number;

    /** Total of any scheduled deferred down payments associated with the sale. */
    public deferred: number;

    /** Total of all deposits, initial and deferred downs associated with the sale.  */
    public downs: number;

    /** Total sale price of any accessories associated with the sale. */
    public accessories: number;

    /** Total sale price of any products associated with the sale. */
    public products: number;

    /** An object containing all of the tax, title and license (ttl)fees associated with the sale. */
    public fees: SaleTaxAndFees;

    /** Total of any itemized fees associated with the sale.  */
    public itemized: number;

    /** The inventory tax type chosen for the sale. */
    public inventoryTaxType: string;

    /**  */
    public lateFeePercent: number;

    /**  */
    public referralFee: number;
}